import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
const QuarryPage = () => {
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/k278pUNBYob384y3LzFCt9/Madeleine_Morlet_1.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/quJDNDLwFr6ZpXctYCCKKG/Madeleine_Morlet_2.jpg', 'TEXT_BLOCK', 'https://uploadthingy.s3.us-west-1.amazonaws.com/u9BKR4eWkBQweagZty9T8C/Madeleine_Morlet_3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/5HdUXpAEnygFvnprkeJjaA/Madeleine_Morlet_4.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4C2Au3sSLogDPKFbABUuzt/Madeleine_Morlet_5.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/tGg9DY3PyoU3fTPvhitQ1u/Madeleine_Morlet_6.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4KTzqv6r3EJjjjapBGoaHG/Madeleine_Morlet_7.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/boZWPYM2G9DDbXLfDmcTGd/Madeleine_Morlet_8.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/tEAvFDRevS83oNpKLXTxib/Madeleine_Morlet_9.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/bWmYuX3nGrXyGY5ndqUGkF/Madeleine_Morlet_10.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/cvtieYqZkVTXJC9aXMwnLU/Madeleine_Morlet_11.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/h8JtKF1eWwK71tK5pPheFn/Madeleine_Morlet_12.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/xaPcAab7oVGJSrqsh4cR5X/Madeleine_Morlet_13.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/n5n38K26gBLkyX8zv4SbTi/Madeleine_Morlet_14.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ob43ZJF4dwxhyFjku8Xnsw/Madeleine_Morlet_15.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/wV7hQMsDfQEDbHSyvDPuiG/Madeleine_Morlet_16.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9B2RoA9imXALxwJABwqaeY/Madeleine_Morlet_17.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/c6484uPeHNFWLQ9XoVpS7N/Madeleine_Morlet_18.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/sYHYdihEQWiHhb9FiXk4jk/Madeleine_Morlet_19.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/s5gEUd4qarznVJ8BQNhKhD/Madeleine_Morlet_20.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mZacCaDf9fq23DF4FmcMuo/Madeleine_Morlet_21.jpg'];
  const getSpacing = index => {
    // Special case for text block transitions
    if (index === 1) return 2; // Reduced spacing before text block
    if (index === 2) return 2; // Reduced spacing after text block
    const spacings = [8, 14, 10, 16, 12, 18, 9, 15];
    return spacings[index % spacings.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '70vh'; // First image consistent
    if (index === 1) return '85vh'; // Make second actual image larger
    const sizes = ['80vh', '65vh', '75vh', '70vh', '85vh'];
    return sizes[index % sizes.length];
  };
  // Text block content for both desktop and mobile
  const textBlockContent = <div className="italic leading-relaxed" data-id="element-415">
      <p className="pl-4" data-id="element-416">
        Years before Georgia went missing, they'd had their first drinks
        together. It was Georgia who had pulled a bottle–a glass globe with real
        flakes of gold drifting in cinnamon liquor–out of her bag at the dock.
        They sat and sipped and tossed stones into the black water, voices
        whisked away by wind coming in off the waves. They were best friends.
      </p>
      <p className="pl-4 indent-8" data-id="element-417">
        Clare knew where all of Georgia's scars were–a dog bite on her ankle,
        and a burn on her inner arm–and Georgia knew hers–a small slice on her
        lip from a knife she'd licked. Clare could tell the difference between
        different kinds of sleepiness in Georgia's voice, one when she first
        woke up in the morning and one late at night, when she was almost
        asleep. She could picture the way Georgia's hair swirled at her temples
        and the loops of her fingerprints.
      </p>
      <p className="pl-4 indent-8" data-id="element-418">
        Clare and Georgia met in fifth grade and grew close over the twisted
        knot of emotions they shared about their parents. Georgia had been
        adopted by a single woman who did so out of a Christian sense of
        righteousness rather than love or even interest. This led Bernice,
        Georgia's adoptive mother, to expect gratitude from Georgia, like she
        had done her a holy favor for which Georgia was forever in her debt.
        Clare's own mother had been the stable one of her two parents and, when
        she died three years before, Clare was left with a booze-soaked
        fisherman father who had started dating younger women months after the
        funeral.
      </p>
      <p className="pl-4 indent-8" data-id="element-419">
        Georgia's dark humor helped Clare. And Clare was a good listener for
        Georgia. Clare let Georgia rant because, for Georgia, anger was the main
        ingredient churning in her stomach. For Clare, it was cold sadness.
      </p>
      <p className="pl-4 indent-8" data-id="element-420">
        When they were eighteen, years after the night they swallowed the gold
        flakes, both Clare and Georgia got the fat college acceptance letters in
        their mailboxes but none from the same schools. Clare went away to hers
        and Georgia went to another. All year they talked, Georgia yelling into
        the phone from a party, Clare turning down the volume at the library.
      </p>
      <p className="pl-4 indent-8" data-id="element-421">
        Georgia's first summer break began just one week before Clare's but
        Georgia dreaded that week, she said. Georgia would be back in their
        hometown by herself.
      </p>
    </div>;
  return <div className="min-h-screen bg-white text-[#333333] font-serif" data-id="element-422">
      <Header data-id="element-423" />
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-424">
        <div className="flex min-w-max" data-id="element-425">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '20vh' // Reduced from 24vh to 20vh
        }} data-id="element-426">
            <div className="text-base max-w-[360px] pr-4" data-id="element-427">
              <div className="mb-6" data-id="element-428">The Quarry (Self-published, 2022)</div>
              <div className="text-sm leading-relaxed" data-id="element-429">
                <p data-id="element-430">Digital Broadsheet</p>
                <p data-id="element-431">20 pages/ 16 Images</p>
                <p data-id="element-432">350mm x 500mm</p>
                <p data-id="element-433">
                  Short Story by{' '}
                  <a href="https://www.vivianewing.com/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-434">
                    Vivian Ewing
                  </a>
                </p>
                <p data-id="element-435">First Edition of 300</p>
                <p data-id="element-436">$17 + $5 USA Domestic Shipping</p>
                <p data-id="element-437">£17 + £5 UK/Europe Domestic Shipping</p>
                <p className="mt-6" data-id="element-438">
                  This is the story of two best friends, fresh out of their
                  first year at college, returning home to their small town in
                  coastal Maine. The photographs illustrate the landscape and
                  community of young adults who live there.
                </p>
                <p className="mt-6" data-id="element-439">
                  Review:{' '}
                  <a href="https://blog.photoeye.com/2022/08/book-of-week-selected-by-odette-england.html" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-440">
                    Book of the Week: Selected by Odette England
                  </a>
                </p>
                <p data-id="element-441">Stock list: Photo-Eye Bookstore SOLD OUT</p>
                <p data-id="element-442">Please enquire directly for remaining copies.</p>
                <p className="mt-6 text-xs italic" data-id="element-443">
                  Funded in part by a grant from the Maine Arts Commission; an
                  independent state agency supported by the National Endowment
                  for the Arts.
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-444">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-445">
                {image === 'TEXT_BLOCK' ? <div className="w-[800px] mx-auto px-4" style={{
              height: '70vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column'
            }} data-id="element-446">
                    <div className="text-[#333333]" data-id="element-447">{textBlockContent}</div>
                  </div> : <img src={image} alt={`The Quarry - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-448" />}
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-449">
        <div className="mb-6" data-id="element-450">
          <div className="text-base mb-4" data-id="element-451">
            The Quarry (Self-published, 2022)
          </div>
          <div className="text-sm leading-relaxed mb-6" data-id="element-452">
            <p data-id="element-453">Digital Broadsheet</p>
            <p data-id="element-454">20 pages/ 16 Images</p>
            <p data-id="element-455">350mm x 500mm</p>
            <p data-id="element-456">
              Short Story by{' '}
              <a href="https://www.vivianewing.com/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-457">
                Vivian Ewing
              </a>
            </p>
            <p data-id="element-458">First Edition of 300</p>
            <p data-id="element-459">$17 + $5 USA Domestic Shipping</p>
            <p data-id="element-460">£17 + £5 UK/Europe Domestic Shipping</p>
            <p className="mt-4" data-id="element-461">
              This is the story of two best friends, fresh out of their first
              year at college, returning home to their small town in coastal
              Maine. The photographs illustrate the landscape and community of
              young adults who live there.
            </p>
            <p className="mt-4" data-id="element-462">
              Review:{' '}
              <a href="https://blog.photoeye.com/2022/08/book-of-week-selected-by-odette-england.html" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-463">
                Book of the Week: Selected by Odette England
              </a>
            </p>
            <p data-id="element-464">Stock list: Photo-Eye Bookstore SOLD OUT</p>
            <p data-id="element-465">Please enquire directly for remaining copies.</p>
            <p className="mt-4 text-xs italic" data-id="element-466">
              Funded in part by a grant from the Maine Arts Commission; an
              independent state agency supported by the National Endowment for
              the Arts.
            </p>
          </div>
        </div>
        <div className="w-full space-y-8" data-id="element-467">
          {images.map((image, index) => {
          if (image === 'TEXT_BLOCK') {
            return <div key={index} className="w-full text-sm mb-8" data-id="element-468">
                  {textBlockContent}
                </div>;
          }
          return <div key={index} className="w-full" data-id="element-469">
                <img src={image} alt={`The Quarry - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-470" />
              </div>;
        })}
        </div>
      </div>
      <ScrollIndicator data-id="element-471" />
      <style jsx data-id="element-472">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default QuarryPage;